import React from 'react'
import { Link, graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import GradientTextLink from 'src/components/GradientTextLink'
import Layout from 'src/components/Layout'
import { Seo } from 'src/components/seo'

export default function BlogPage({ data }) {
  console.log(data.blog)

  const {
    seoTitle,
    seoDescription,
    metaDescription,
    slug,
    title,
    thumbnail,
    description,
    content,
    ctaText,
    ctaLink,
  } = data.blog

  return (
    <Layout className='tailwindcss'>
      <Seo
        title={`${seoTitle} | ${seoDescription}`}
        description={metaDescription}
        pathname={`/${slug}`}
        image={thumbnail?.file?.url}
      />
      <div className='blog-wrapper container'>
        <h1 className='font-bold'>{title}</h1>
        <GatsbyImage image={thumbnail.gatsbyImageData} alt={thumbnail.title} />
        <div
          dangerouslySetInnerHTML={{
            __html: description.childMarkdownRemark.html,
          }}
        />
        <div
          dangerouslySetInnerHTML={{ __html: content.childMarkdownRemark.html }}
        />
        {ctaText && ctaLink && (
          <Link to={ctaLink} className='mx-auto my-[24px] block w-[220px]'>
            <button
              type='submit'
              className='bg-blue-gradient w-full px-[20px] py-[16px] uppercase'
            >
              <GradientTextLink
                title={ctaText}
                type='white'
                className='mx-auto'
              />
            </button>
          </Link>
        )}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query ($id: String!) {
    blog: contentfulBlogPost(id: { eq: $id }) {
      seoTitle
      seoDescription
      metaDescription
      title
      slug
      thumbnail {
        title
        gatsbyImageData
        file {
          url
        }
      }
      description {
        childMarkdownRemark {
          html
        }
      }
      content {
        childMarkdownRemark {
          html
        }
      }
      ctaText
      ctaLink
    }
  }
`
